import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { IButton } from 'src/common/interfaces/IButton';
import { styles } from './process-tender/tender-processing-buttons-styles';

interface TenderViewButtonsProps {
  secondaryButton?: IButton;
  primaryButton?: IButton;
}

const TenderViewButtons = ({
  primaryButton,
  secondaryButton,
}: TenderViewButtonsProps): JSX.Element => {
  const classes = styles();

  return (
    <>
      {secondaryButton && (
        <BaseButton
          buttonType='white'
          className={classes.button}
          onClick={() => secondaryButton.onClick()}
          data-testid='secondary-button'
        >
          {secondaryButton.label}
        </BaseButton>
      )}
      {primaryButton && (
        <BaseButton
          buttonType='primary'
          className={classes.button}
          onClick={() => primaryButton.onClick()}
          data-testid='primary-button'
        >
          {primaryButton.label}
        </BaseButton>
      )}
    </>
  );
};

export default TenderViewButtons;
